import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn } from '@angular/router';
import { VersionCheckService } from './version-check.service';

export const versionCheckGuard: CanActivateFn & CanActivateChildFn = () => {
	inject(VersionCheckService).check();
	return true;
};